import React, { lazy, useEffect } from 'react';
import LazySection from 'components/lazySection';
import SectionSkeleton from './sectionskeleton';
import CIOffsiteProject from 'components/Commercial-Industrial/offsite/ciOffsiteProject';
import { useLocation } from 'react-router-dom';
const CIOffsiteSuccessStories = lazy(() => import("components/Commercial-Industrial/offsite/cioffsiteSuccesstories"));
const CIoffsiteBrand = lazy(() => import("components/Commercial-Industrial/offsite/cioffsitebrand"));
const Offsitebileteral = lazy(() => import("components/Commercial-Industrial/offsite/offsitebileteral"));
const Offsitegrpcap = lazy(() => import("components/Commercial-Industrial/offsite/offsitegrpcap"));
const OffsiteEllndus = lazy(() => import("components/Commercial-Industrial/offsite/offsiteEIIndus"));
const OffsiteWhy = lazy(() => import("components/Commercial-Industrial/offsite/offsiteWhy"));
const CommIndOffsiteBanner = lazy(() => import("components/Commercial-Industrial/offsite/ciOffsiteBanner"));
const OffsiteAbout = lazy(() => import("components/Commercial-Industrial/offsite/offsiteAbout"));



const CommIndOffsite: React.FC = () => {
    const { pathname } = useLocation();
  useEffect(() => {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    
    
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      });
    
    
  }, [pathname]);
  return (
    <>
      <CommIndOffsiteBanner />

      {/* Lazy load sections when visible */}
        <LazySection fallback={<SectionSkeleton height={400} />}>
        <OffsiteAbout />
      </LazySection> 

    
    <LazySection fallback={<SectionSkeleton height={400} />}>
        <OffsiteWhy />
      </LazySection>

      <LazySection fallback={<SectionSkeleton height={400} />}>
        <OffsiteEllndus />
      </LazySection>
      
     <LazySection fallback={<SectionSkeleton height={400} />}>
        <Offsitebileteral />
      </LazySection>

       <LazySection fallback={<SectionSkeleton height={400} />}>
        <Offsitegrpcap />
      </LazySection>
      {/*   */}

       <LazySection fallback={<SectionSkeleton height={400} />}>
        <CIOffsiteSuccessStories />
      </LazySection>

       <LazySection fallback={<SectionSkeleton height={400} />}>
        <CIOffsiteProject />
      </LazySection>

       <LazySection fallback={<SectionSkeleton height={400} />}>
        <CIoffsiteBrand />
      </LazySection> 
      
    </>
  );
};

export default CommIndOffsite;
